import { render, staticRenderFns } from "./SendEmailAction.vue?vue&type=template&id=985eb7bc&scoped=true"
import script from "./SendEmailAction.vue?vue&type=script&lang=js"
export * from "./SendEmailAction.vue?vue&type=script&lang=js"
import style0 from "./SendEmailAction.vue?vue&type=style&index=0&id=985eb7bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985eb7bc",
  null
  
)

export default component.exports